"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function deepEqual(a, b) {
    return compareDeep(a, b);
}
exports.deepEqual = deepEqual;
function compareDeep(a, b, aCache, bCache) {
    if (aCache === void 0) { aCache = []; }
    if (bCache === void 0) { bCache = []; }
    if (a === b) {
        return true;
    }
    else if (isNotPrimitive(a) && isNotPrimitive(b)) {
        return compareDeepNonPrimitives(a, b, aCache, bCache);
    }
    else {
        return false;
    }
}
function isNotPrimitive(possibleObj) {
    return typeof possibleObj === 'object' && possibleObj != null;
}
function compareDeepNonPrimitives(a, b, aCache, bCache) {
    var indexOfA = aCache.indexOf(a);
    if (indexOfA === -1) {
        aCache.push(a);
        bCache.push(b);
        var aObjKeys = Object.keys(a);
        var bObjKeys = Object.keys(b);
        return aObjKeys.length === bObjKeys.length &&
            aObjKeys.every(function (key) { return key in b ? compareDeep(a[key], b[key], aCache, bCache) : false; });
    }
    else {
        return indexOfA === bCache.indexOf(b);
    }
}
